import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import _range from 'lodash/range';
import { DropdownPillMenu } from 'components/Dropdown';
import messages from '../../ScheduleForm.messages';
import './CapacityInput.scss';

const NOT_SPECIFIED_KEY = 'not-specified';
const PLACEHOLDER = '-';

const CapacityInput = ({ input: { value, onChange }, disabled }) => {
  const intl = useIntl();
  const items = [
    { label: intl.formatMessage(messages.inputs.capacity.notSpecified), key: NOT_SPECIFIED_KEY },
    ..._range(1, 101).map(number => ({ label: number, key: number })),
  ];

  if ((!!value || value === 0) && !items.some(({ key }) => key === value)) {
    items.push({
      label: value,
      key: value,
    });
  }

  return (
    <DropdownPillMenu
      attachment="left"
      items={items}
      getKey="key"
      getText="label"
      isSelected={({ key }) => key === value}
      onSelect={({ key }) => onChange(key)}
      renderSelectedItem={text => (text || text === 0 ? text : PLACEHOLDER)}
      className="capacity-input"
      isWide
      renderAsActive={false}
      disabled={disabled}
    />
  );
};

CapacityInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onChange: PropTypes.func,
  }),
  disabled: PropTypes.bool,
};

export default CapacityInput;
